<template>
	<div class="personalSet ">
		<div class="flex items-center justify-between pb-[6px] bB-03">
			<div class="flex items-center">
				<div @click="navClick(item,index)" v-for="(item,index) in navList" :key="index"
					:class="type==index?'active text-[#FF0000] font-bold':'text-[#1C1F21]'"
					class="navTitle cursor-pointer  relative text-[16px] mr-[34px]">
					{{item.title}}
				</div>
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: "myCollect",
		data() {
			return {
				type: 0,
				navList: [{
						title: '', //课程
						path: '/personalCenter/myCollect/courseCollect?type=0'
					},
					{
						title: '', //资讯
						path: '/personalCenter/myCollect/newsCollect?type=1'
					},
					{
						title: '', //资源
						path: '/personalCenter/myCollect/resourcesCollect?type=2'
					}
				],
			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				console.log(to.query.type); // 获取查询参数
				// 你可以在这里处理查询参数的变化
				this.type = to.query.type
			}
		},
		mounted() {
			if (this.$route.query.type) {
				this.type = this.$route.query.type
			}



			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				document.title =this.langInfo.pc_name+'-'+ this.langInfo.study_my_collect;
				this.setNavList()
			}

		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.setNavList()
					document.title =this.langInfo.pc_name+'-'+ this.langInfo.study_my_collect;
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			setNavList() {
				this.navList[0].title = this.langInfo.course_title
				this.navList[1].title = this.langInfo.news_title
				this.navList[2].title = this.langInfo.resources_title
			},
			navClick(item, index) {
				if (item.path) {
					if (this.$route.fullPath == item.path) {
						// 如果相同则不进行导航
						return;
					}
					this.type = index
					this.$router.push(item.path); // 使用完整路径
				}
			}
		}
	};
</script>

<style scoped>
	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 100%;
		height: 4px;
		background-color: #FF0000;
		bottom: -12px;
		left: 50%;
		transform: translateX(-50%);

	}

	.navTitle:nth-last-child(1) {
		margin-right: 0;
	}
</style>